import { HttpClient } from 'shared/libs/http';
import {
   AlertActivateDto,
   AlertDeactivateDto,
   AlertDeleteDto,
   AlertDeleteResponse,
   AletrsIndexResponse,
} from './types';

export class ManageAlertsApiService {
   public static async loadAlerts<TDto extends null>(dto: TDto, {}: {}) {
      return await HttpClient.post<AletrsIndexResponse>('/alerts/index', dto);
   }

   public static async activateAlert<TDto extends AlertActivateDto>(dto: TDto, opts?: {}) {
      return await HttpClient.post<AlertDeleteResponse>('/alerts/activate-alert/' + dto.id, null);
   }

   public static async deactivateAlert<TDto extends AlertDeactivateDto>(dto: TDto, opts?: {}) {
      return await HttpClient.post<AlertDeleteResponse>('/alerts/deactivate-alert/' + dto.id, dto);
   }

   public static async deleteAlert<TDto extends AlertDeleteDto>(
      dto: TDto,
      opt: { adminID?: string; tokenKey?: string } = {}
   ) {
      return await HttpClient.post<AlertDeleteResponse>('/alerts/delete/' + dto.slug, null);
   }
}
